import { Trans, useTranslation } from 'react-i18next';
import { DesignIcon } from '@monorepo/nova-icons';
import { Button, Stack, Typography } from '@monorepo/nova-ui';
import {
  ButtonsContainer,
  IconWrapper,
  ModalContent,
  StyledDialog,
} from './styled';

interface WithdrawalConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const WithdrawalConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: WithdrawalConfirmationModalProps) => {
  const { t } = useTranslation(['withdrawFunds', 'common']);

  return (
    <StyledDialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <ModalContent>
        <IconWrapper>
          <DesignIcon iconName="DollarNote" useMuiSvgIcon={false} />
        </IconWrapper>
        <Typography variant="h3">{t('confirmation_modal.title')}</Typography>

        <Stack spacing={1.5}>
          <Typography variant="body1">
            <Trans
              i18nKey="withdrawFunds:confirmation_modal.message"
              components={{ br: <br /> }}
            />
          </Typography>
          <Typography variant="body1" fontWeight="medium">
            {t('confirmation_modal.question')}
          </Typography>
        </Stack>

        <ButtonsContainer>
          <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
            {t('confirmation_modal.confirm_button')}
          </Button>
          <Button variant="outlined" onClick={onClose} disabled={isLoading}>
            {t('common:cancel')}
          </Button>
        </ButtonsContainer>
      </ModalContent>
    </StyledDialog>
  );
};
